import { Dialog, DialogPanel } from '@headlessui/react';
import IconSvg from '../ui/IconSvg';
import { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import {useHttp} from "../../../hooks";

interface Props {
  isOpen: boolean;
  selectedRequest: string;
  onClose: (value: boolean) => void;
  parentSetRedemedRequest?: (requestId: string, voucherNumber: string) => void;

}

function SuccessRedeemedModal({ isOpen, onClose, selectedRequest, parentSetRedemedRequest }: Props) {
  const [code, setCode] = useState('');
  const [copied, setCopied] = useState(false);
  const [isViewCode, setIsViewCode] = useState(false);
  const [accessToken, setAccessToken] = useState('');
  const [loggedIn, setLoggedIn] = useState<boolean>(false);
  const { sendRequest } = useHttp();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(code);
    setCopied(true);

    setTimeout(() => setCopied(false), 2000); // Reset copy state after 2 seconds
  };

  const viewCOdeHandler = () => {
    console.log('view the code')
    if (!loggedIn)
      signInWithMetaMask()
    else {
      redeemHandler(selectedRequest, accessToken)
    }
  }

  const redeemHandler = async (selectedRequest: string, token: string) => {
    sendRequest(
      {
        url: `codes/redeem/${selectedRequest}`, // Example endpoint
        method: 'PATCH',
        // payload: { selectedRequest },
        headers: {
          Authorization: `Bearer ${token}`,
          'X-Api-Key': process.env.REACT_APP_API_KEY as string,
        },

      },
      async (response: any) => {
        setCode(response.voucherNumber);
        setIsViewCode(!isViewCode)
        if (parentSetRedemedRequest) {
          parentSetRedemedRequest(selectedRequest, response.voucherNumber);
        }
      },
    );
  };

  const requestNonce = async (address: string) => {
    const response = await fetch('http://localhost:3000/auth/request-nonce', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ walletAddress: address }),
    });
    const data = await response.json();
    return data.nonce;
  };

  const verifySignature = async (address: string, signature: string) => {
    const response = await fetch('http://localhost:3000/auth/verify-signature', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ walletAddress: address, signature }),
    });
    const data = await response.json();
    console.log(data)
    return data;
  };

  const signInWithMetaMask = async () => {
    if (!window.ethereum) {
      alert('MetaMask not installed!');
      return;
    }

    const { ethereum } = window;
    const provider = new ethers.providers.Web3Provider(ethereum);
    const signer = await provider.getSigner();
    const address = await signer.getAddress();
    // setWalletAddress(address);

    // Request the nonce from the backend
    const nonce = await requestNonce(address);

    // Sign the exact nonce message
    const signature = await signer.signMessage(nonce);

    // Verify the signature with the backend
    const {success, token, id} = await verifySignature(address, signature);
    console.log('token', {token ,success})
    if (success) {
      setLoggedIn(true)
      setIsViewCode(!isViewCode)
      setAccessToken(token)
      redeemHandler(selectedRequest, token)
    }
  };

  return (
    <Dialog open={isOpen} as="div" className="relative z-10 focus:outline-none" onClose={onClose}>
      <div className="fixed inset-0 z-10 w-screen overflow-y-auto bg-grayscale-900/50">
        <div className="flex items-center justify-center min-h-full p-4">
          <DialogPanel
            transition
            className="relative w-full p-10 border-2 rounded-md max-w-fit bg-grayscale-800 border-grayscale-700"
          >
            <button className="absolute top-[11px] right-[13px]" onClick={() => onClose(false)}>
              <IconSvg icon="closeM" className="text-grayscale-400" />
            </button>

            <div className="w-[607px] space-y-6">
              <img src="/assets/images/check.png" className="w-[181px] h-[181px] mx-auto" />

              <h3 className="text-brand-primary-light leading-10 text-center">
                You have successfully redeemed your reward
              </h3>

              <p className="text-grayscale-400 font-normal text-sm text-center">
                Copy your promo code and visit qiibee to get VIR.
              </p>

              {/* Here is the input field */}

              {isViewCode ?
              <div className="relative mx-auto max-w-sm">
                <input
                  type="text"
                  value={code || 'loading . . .'}
                  readOnly
                  className="w-full py-2 px-4 bg-grayscale-700 text-[#ADADAD] border border-[#3E3E3E] rounded-md focus:outline-none"
                />

                <button
                  onClick={copyToClipboard}
                  className="absolute top-1/2 right-3 transform -translate-y-1/2 bg-[#3E3E3E] text-[#ADADAD] py-1 px-2 rounded-md hover:text-white transition-all"
                >
                  {copied ? (
                    'Copied!'
                  ) : (
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="13"
                      viewBox="0 0 13 13"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M3 2H8.00009H9H9.00009V4.00001H10H10.9999H11V11H10.9999V11H3.99994V11V10V9.00005H2V9V8.00005V3V2H3ZM8.00009 4.00001V3H3V8.00005H3.99994V5.00001V4.00001H4.99994H8.00009ZM4.99994 9.00005V10H10V5.00001H4.99994V8.00005H5V9.00005H4.99994Z"
                        fill="#EEE0F9"
                      />
                    </svg>
                  )}
                </button>
              </div>
                :
              <img src="/assets/images/blue-input.png" className="h-11 mx-auto cursor-pointer" onClick={() => viewCOdeHandler()} />
              }

              <div
                className="flex items-center justify-center w-fit mx-auto space-x-6"
                onClick={() => onClose(false)}
              >
                <svg
                  width="125"
                  height="42"
                  className="cursor-pointer"
                  viewBox="0 0 125 42"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.83333 42V38.5946H4.16667V35.1892H0.5V6.81081H4.16667V3.40541H7.83333V0H11.5V42H7.83333Z"
                    fill="#B73FFF"
                  />
                  <rect width="104" height="42" transform="translate(10.5)" fill="#B73FFF" />
                  <path
                    d="M33.7859 27.16C33.0499 27.16 32.4045 27.0213 31.8499 26.744C31.3059 26.4667 30.8845 26.072 30.5859 25.56C30.2872 25.0373 30.1379 24.4293 30.1379 23.736V18.584C30.1379 17.88 30.2872 17.272 30.5859 16.76C30.8845 16.248 31.3059 15.8533 31.8499 15.576C32.4045 15.2987 33.0499 15.16 33.7859 15.16C34.5325 15.16 35.1725 15.304 35.7059 15.592C36.2499 15.8693 36.6712 16.264 36.9699 16.776C37.2685 17.2773 37.4179 17.88 37.4179 18.584H35.5619C35.5619 18.008 35.4072 17.5707 35.0979 17.272C34.7885 16.9627 34.3512 16.808 33.7859 16.808C33.2205 16.808 32.7779 16.9627 32.4579 17.272C32.1485 17.5707 31.9939 18.008 31.9939 18.584V23.736C31.9939 24.3013 32.1485 24.744 32.4579 25.064C32.7779 25.3733 33.2205 25.528 33.7859 25.528C34.3512 25.528 34.7885 25.3733 35.0979 25.064C35.4072 24.744 35.5619 24.296 35.5619 23.72V22.488H33.4659V20.856H37.4179V23.736C37.4179 24.4293 37.2685 25.032 36.9699 25.544C36.6712 26.056 36.2499 26.456 35.7059 26.744C35.1725 27.0213 34.5325 27.16 33.7859 27.16ZM43.3156 27.16C42.5903 27.16 41.9556 27.0213 41.4116 26.744C40.8676 26.456 40.4463 26.056 40.1476 25.544C39.849 25.0213 39.6996 24.4187 39.6996 23.736V21.464C39.6996 20.7813 39.849 20.184 40.1476 19.672C40.4463 19.1493 40.8676 18.7493 41.4116 18.472C41.9556 18.184 42.5903 18.04 43.3156 18.04C44.0516 18.04 44.6863 18.184 45.2196 18.472C45.7636 18.7493 46.185 19.1493 46.4836 19.672C46.7823 20.184 46.9316 20.7813 46.9316 21.464V23.048H41.4916V23.736C41.4916 24.3653 41.6463 24.8453 41.9556 25.176C42.2756 25.5067 42.7343 25.672 43.3316 25.672C43.8116 25.672 44.1956 25.5867 44.4836 25.416C44.7823 25.2453 44.969 25.0053 45.0436 24.696H46.8836C46.745 25.4427 46.3503 26.04 45.6996 26.488C45.049 26.936 44.2543 27.16 43.3156 27.16ZM45.1396 21.96V21.464C45.1396 20.8347 44.985 20.3547 44.6756 20.024C44.377 19.6827 43.9236 19.512 43.3156 19.512C42.729 19.512 42.2756 19.6827 41.9556 20.024C41.6463 20.3653 41.4916 20.8453 41.4916 21.464V21.832L45.2676 21.816L45.1396 21.96ZM53.8694 27C53.048 27 52.408 26.776 51.9494 26.328C51.4907 25.8693 51.2614 25.24 51.2614 24.44V19.88H48.8454V18.2H51.2614V15.72H53.1174V18.2H56.5414V19.88H53.1174V24.44C53.1174 25.0267 53.4054 25.32 53.9814 25.32H56.3814V27H53.8694ZM70.8809 27L67.9209 15.32H69.8409L71.6649 23.016C71.7715 23.432 71.8675 23.8587 71.9529 24.296C72.0382 24.7333 72.1022 25.0853 72.1449 25.352C72.1875 25.0853 72.2462 24.7333 72.3209 24.296C72.4062 23.8587 72.5022 23.4267 72.6089 23L74.4009 15.32H76.2729L73.3129 27H70.8809ZM78.3946 27V25.352H80.7466V16.968H78.3946V15.32H84.9866V16.968H82.6346V25.352H84.9866V27H78.3946ZM87.7644 27V15.32H91.4444C92.2017 15.32 92.8577 15.464 93.4124 15.752C93.9777 16.0293 94.415 16.4293 94.7244 16.952C95.0337 17.464 95.1884 18.0667 95.1884 18.76C95.1884 19.5387 94.991 20.2213 94.5964 20.808C94.2017 21.384 93.6684 21.7893 92.9964 22.024L95.3484 27H93.2524L91.1564 22.28H89.6204V27H87.7644ZM89.6204 20.632H91.4444C92.0097 20.632 92.4577 20.472 92.7884 20.152C93.1297 19.8213 93.3004 19.3733 93.3004 18.808C93.3004 18.2427 93.1297 17.7947 92.7884 17.464C92.4577 17.1333 92.0097 16.968 91.4444 16.968H89.6204V20.632Z"
                    fill="black"
                  />
                  <path
                    d="M117.167 42V38.5946H120.833V35.1892H124.5V6.81081H120.833V3.40541H117.167V0H113.5V42H117.167Z"
                    fill="#B73FFF"
                  />
                </svg>
              </div>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  );
}

export default SuccessRedeemedModal;
